/* eslint-disable no-unused-vars */
import axios from 'axios';
import api from '@src/api';
import _ from 'lodash';
import localStorage from '@state/localStorage';
const appConfig = require('@src/app.config');

export const state = initialState();

// state is function so it can be instantiated again - reset
function initialState() {
  return {
    onBoardingProgress: localStorage.getSavedState('onBoardingProgress') || 0,
  };
}

export const getters = {
  clientId(state, getters, rootState, rootGetters) {
    if (rootGetters['auth/loggedIn']) {
      return rootState.auth.currentUser.user._id;
    } else {
      return '';
    }
  },
  trainerId(state, getters, rootState, rootGetters) {
    if (rootGetters['auth/loggedIn']) {
      return rootState.auth.currentUser.user.trainer_id;
    } else {
      return '';
    }
  },
  orgId(state, getters, rootState, rootGetters) {
    if (rootGetters['auth/loggedIn']) {
      return rootState.auth.currentUser.user.org_id;
    } else {
      return '';
    }
  },
  completedOnBoarding(state, getters, rootState, rootGetters) {
    return rootState.auth.currentUser.user.completedOnBoarding;
  },
  // Whether the user has completed onboarding
  initialLandingPage(state, getters, rootState, rootGetters) {
    return state.onBoardingProgress;
  },
  isSubscribed(state, getters, rootState, rootGetters) {
    return rootState.auth.currentUser.user.profile.subscribed;
  },
};

export const mutations = {
  updateOnboardingProgress(state, newValue) {
    state.onBoardingProgress = newValue;
    localStorage.saveState('onBoardingProgress', state.onBoardingProgress);
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  // METHOD SignUp
  signUp({ commit, state, rootState }, { trainerId, email, password } = {}) {
    if (trainerId.length < 24) {
      return { success: false, errorMessage: 'trainerId is invalid' };
    }
    if (email.length < 5) {
      return { success: false, errorMessage: 'email is invalid' };
    }
    if (password.length < 1) {
      return { success: false, errorMessage: 'password is invalid' };
    }

    return axios
      .put(api.URL_SIGNUP_CLIENT, { email, password, trainer_id: trainerId })
      .then((response) => response.data)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        return Promise.resolve(error);
      });
  },

  // client change password
  changePassword(context, { password } = {}) {
    return axios
      .post(api.URL_CHANGE_PASSWORD, { password })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response) {
          console.error(error.response);
        } else {
          console.error(error);
        }
        return error;
      });
  },

  // URL_UPDATE_CLIENT: '/client/:clientID?trainer_id=:trainerID',
  updateClient({ commit, state, rootState }, { clientId, trainerId, payload } = {}) {
    if (clientId.length < 24) {
      return { success: false, errorMessage: 'clientId is invalid' };
    }
    if (trainerId.length < 24) {
      return { success: false, errorMessage: 'trainerId is invalid' };
    }

    const url = api.URL_UPDATE_CLIENT.replace(':clientID', clientId).replace(':trainerID', trainerId);

    return axios
      .put(url, payload)
      .then((response) => response.data)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        return Promise.resolve(error);
      });
  },

  startCheckin({ commit, state, rootState }, { clientId, checkinId } = {}) {
    const url = api.URL_START_CHECKIN.replace(':clientID', clientId).replace(':scheduledCheckInID', checkinId);

    return axios
      .get(url)
      .then((response) => response.data)
      .then((response) => {
        return Promise.resolve(response.scheduledCheckIn);
      })
      .catch((error) => {
        console.error(error);
        return Promise.resolve(error);
      });
  },
  updateCheckin({ commit, state, rootState }, { clientId, checkinId, payload } = {}) {
    const url = api.URL_UPDATE_CHECKIN.replace(':clientID', clientId).replace(':scheduledCheckInID', checkinId);

    return axios
      .put(url, payload)
      .then((response) => response.data)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        return Promise.resolve(error);
      });
  },
  completeCheckin({ commit, state, rootState }, { clientId, checkinId } = {}) {
    const url = api.URL_COMPLETE_CHECKIN.replace(':clientID', clientId).replace(':scheduledCheckInID', checkinId);

    return axios
      .put(url)
      .then((response) => response.data)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        return Promise.resolve(error);
      });
  },
};
